/** 코담 연혁 — 구축 사례·디자인 포트폴리오·프로젝트 진행 체계 반영 */

export const CODAM_FOUNDING_YEAR = 2021

/** @param {number} [asOfYear] */
export function getCodamYearsSinceFounding(asOfYear = new Date().getFullYear()) {
    return Math.max(1, asOfYear - CODAM_FOUNDING_YEAR)
}

/**
 * @type {Array<{ year: string, events: string[] }>}
 */
export const codamHistoryTimeline = [
    {
        year: '2026',
        events: [
            '디지털 자산 거래 플랫폼 웹 구축 — 랜딩·스팟 거래·자산·출금·보안(2FA·PIN)까지 반응형 UI 개발',
            '코담 공식 브랜드 마스코트 캐릭터 — 턴라운드·포즈 세트·활용 가이드 정리',
            '클라우드·AI 통합 구축 프로그램을 확대하고, 기업 디지털 전환 컨설팅 조직을 강화',
        ],
    },
    {
        year: '2025',
        events: [
            '누적 30+ 파트너사 프로젝트 완료',
            '요구사항 분석 → 설계 → 애자일 개발 → 품질 검수 → 배포·운영 지원 전사 프로세스 정착',
            '운영 자동화 및 보안·모니터링 고도화 솔루션 적용 확대',
        ],
    },
    {
        year: '2024',
        events: [
            '통합 B2C 온라인 쇼핑몰 웹 구축 및 Android·iOS 네이티브 앱 납품',
            '블록체인 생태계 웹·앱 — NFT·스테이킹·관리자·모바일 UI 통합 브랜드 구축',
            '핵심 산업군 대상 기업용 웹 플랫폼 구축 본격화',
            '데이터 기반 의사결정 지원 대시보드 서비스 출시',
        ],
    },
    {
        year: '2023',
        events: [
            '제품 디자인: RiceKeeper, MODU 흡입기, Arrow Drone, WINIA Green View, 유아 콧물 흡입기, Pet Friends 등 다수 납품',
            '산업·제품 디자인: Ducati Laser 의료용 레이저(관절 암·터치 UI·스튜디오 렌더)',
            '코담 기술 표준 프레임워크 수립 및 프로젝트 품질 관리 체계 강화',
        ],
    },
    {
        year: '2022',
        events: [
            '제품 디자인: 말려슈S 신발건조기·말려줘 스마트 펫 드라이어 시리즈',
            '서비스 출시 국가 확장(누적 5+)',
            '기업용 백오피스·운영 관리 시스템 구축 확대',
        ],
    },
    {
        year: '2021',
        events: ['코담 창립', '기업 맞춤형 IT 솔루션 제공 시작'],
    },
]

export const codamHistoryIntro = {
    subTitle: `${CODAM_FOUNDING_YEAR}년부터`,
    title: '코담 연혁',
    lede: 'IT 구축과 제품·산업·캐릭터 디자인까지, 코담이 걸어온 성장의 발자취입니다.',
}
